var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseResourceApi = void 0;
class BaseResourceApi {
  constructor(api) {
    this.commonPath = "/api/v2";
    this.api = api;
  }
  buildAnalyticsUri() {
    return `${this.commonPath}/analytics`;
  }
  buildArSceneUri() {
    return `${this.commonPath}/ar-scene`;
  }
  buildAuthGroupUri() {
    return `${this.commonPath}/auth_group`;
  }
  buildTicketUri(ticketId) {
    return `${this.commonPath}/ticket/${ticketId}`;
  }
  buildSessionUri(sessionId) {
    return `${this.commonPath}/session/${sessionId}`;
  }
  buildModelUri(modelId) {
    return `${this.commonPath}/model/${modelId}`;
  }
  buildSystemUri() {
    return `${this.commonPath}/system`;
  }
}
exports.BaseResourceApi = BaseResourceApi;
//# sourceMappingURL=BaseResourceApi.js.map
export default exports;